import { createAuthProvider } from "react-token-auth";

const Session = {accessToken:null,refrehToken:null};

export const { useAuth, authFetch, login, logout } = createAuthProvider({
    getAccessToken: session => session.accessToken,
    storage: localStorage,
    onUpdateToken: token => fetch('/update-token',{
        method: 'POST',
        body: token.refrehToken,
    }).then( r => r.json()),
})